import React, { forwardRef } from 'react';

import PropTypes from 'prop-types';

import ProgressRing from '@adsk/alloy-react-progress-ring';
import { stylePropType } from '@adsk/alloy-react-theme';

import { TreeNode } from '../index';
import { TreeNodeProps } from '../TreeNode';

type ProgressNodeProps = Omit<TreeNodeProps, 'id' | 'label'>;

const ProgressNode = forwardRef<HTMLLIElement, ProgressNodeProps>(
  ({ depth = 0, style, ...props }, ref) => {
    if (depth <= 0) return null;
    return (
      <TreeNode
        id=""
        ref={ref}
        label=""
        depth={depth}
        style={{ ...(style as object) }}
        {...props}
      >
        <ProgressRing size="small" />
      </TreeNode>
    );
  },
);
ProgressNode.displayName = 'ProgressNode';

ProgressNode.propTypes = {
  /* Determines whether to display the current node */
  show: PropTypes.bool.isRequired,
  /* style object to add to the wrapper of the node */
  depth: PropTypes.number,
  /* style object to add to the wrapper of the node */
  style: stylePropType,
};

export default ProgressNode;
